import styled from 'styled-components';

import { media, zIndex } from '~/src/styles-constants';

import colors from '../../themes/main/colors';
import { StyledInput as CommonInput } from '../Form/Input';
import Icon from '../Icon';

export const Container = styled.div`
  position: relative;
  flex-grow: 1;
  z-index: 2;
`;

export const Menu = styled.ul<{ $hasResults: boolean }>`
  position: absolute;
  z-index: 10;
  overflow: hidden;

  width: 100%;
  margin-top: 8px;
  list-style-type: none;

  padding-left: 0;

  border-radius: 8px;
  ${({ $hasResults, theme }) =>
    $hasResults ? `border: 1px solid ${theme.palette.common.BACKGROUND_3}` : 'border: none;'}
`;

export const Item = styled.li<{ $isHighlighted?: boolean }>`
  line-height: 22px;
  padding: 10px 17px;

  background-color: ${({ $isHighlighted, theme }) =>
    $isHighlighted ? theme.palette.primary : theme.palette.common.WHITE};
  cursor: pointer;
  color: ${({ $isHighlighted, theme }) =>
    $isHighlighted ? theme.palette.common.WHITE : theme.palette.common.DISABLED};

  /* highlight typed letters */
  & .highlight {
    color: ${({ $isHighlighted, theme }) =>
      $isHighlighted ? theme.palette.common.WHITE : theme.palette.primary};
  }
`;

export const NoResult = styled.div<{ $emptyPlaces: boolean }>`
  line-height: 22px;
  padding: 10px 17px;

  background-color: ${({ theme }) => theme.palette.common.WHITE};

  ${({ $emptyPlaces, theme }) =>
    $emptyPlaces
      ? `
        border: 1px solid ${theme.palette.common.BACKGROUND_3};
        border-radius: 8px;
      `
      : `border-top: 1px solid ${theme.palette.common.BACKGROUND_3};`}
`;

export const Loading = styled.div`
  line-height: 22px;
  padding: 10px 17px;

  background-color: ${({ theme }) => theme.palette.common.WHITE};
  border: 1px solid ${({ theme }) => theme.palette.common.BACKGROUND_3};
  border-radius: 8px;

  text-align: center;
  color: ${({ theme }) => theme.palette.common.DISABLED};
  font-style: italic;
`;

export const StreetNumberMissingErrorMessage = styled.div`
  line-height: 22px;

  position: absolute;
  top: 70px;
  right: 0;
  left: 0;

  padding: 10px 17px;
  border-radius: 8px;
  box-shadow:
    0 0 20px 4px rgb(154 161 177 / 15%),
    0 4px 80px -8px rgb(36 40 47 / 25%),
    0 4px 4px -2px rgb(91 94 105 / 15%);

  color: ${({ theme }) => theme.palette.common.TEXTS};
  background-color: ${({ theme }) => theme.palette.common.WHITE};
  text-align: center;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: -18px;
    left: 13px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent ${({ theme }) => theme.palette.common.WHITE} transparent;

    ${media.M`
      left: 24px;
    `}
  }
`;

export const SearchIcon = styled(Icon)`
  position: absolute;
  top: 16px;
  left: 20px;
  width: 24px;

  ${media.M`
    left: 21px;
    right: 16px;
  `}
`;

export const ClearIcon = styled(Icon)`
  position: absolute;
  top: 17px;
  right: 7px;
  cursor: pointer;

  ${media.M`
    right: 16px;
  `}
`;

export const GeolocIconWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  top: 0;
  z-index: 2;
  cursor: pointer;
  width: 56px;
  height: 56px;
`;

export const GeolocIcon = styled(Icon)`
  &::after {
    content: '';
    position: absolute;
    top: 18px;
    left: 0;
    width: 1px;
    height: 20px;
    background: ${colors.BACKGROUND_3};
  }

  ${media.M`
    right: 16px;
  `}
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  top: 17px;
  right: 7px;
  width: 40px;
  background: ${({ theme }) => theme.palette.common.TRANSPARENT};
  z-index: ${zIndex.googlePlacesAutocompleteLoader};

  svg {
    margin-bottom: 0;
  }

  ${media.M`
    right: 16px;
  `}
`;

export const StyledInput = styled(CommonInput)<{ $withLeftIcon: boolean }>`
  height: 56px;
  padding: ${({ $withLeftIcon }) => ($withLeftIcon ? '0 55px 0 48px' : '0 55px 0 16px')};

  border: solid 1px ${({ theme }) => theme.palette.common.BACKGROUND_3};

  &:disabled {
    background-color: ${colors.BACKGROUND_4};
  }

  &:focus {
    border: solid 1px ${({ theme }) => theme.palette.common.PRIMARY};
  }

  &::placeholder {
    font-size: 14px !important; /* applique pas la size si pas important */
    font-weight: 500;
    color: ${({ theme }) => theme.palette.common.BLACK};
  }

  &:placeholder-shown {
    text-overflow: ellipsis;
  }

  ${media.M<{ $withLeftIcon: boolean }>`
    padding: ${({ $withLeftIcon }) => ($withLeftIcon ? '0 56px' : '0 16px')};

    &::placeholder {
      font-size: 16px;
    }
  `}
`;
